import translationsDE, { TranslationsDE } from './de'
import translationsFR, { TranslationsFR } from './fr'

export type Translations = TranslationsDE | TranslationsFR

const translations: Translations =
  process.env.NEXT_PUBLIC_PUBLICATION === 'romandie'
    ? translationsFR
    : translationsDE

function translate<T extends keyof Translations>(
  key: T,
  args?: Record<string, string>,
): Translations[T] {
  if (!args) {
    return translations[key] ?? ''
  }

  const res = translations[key].replace(
    /{{(.+?)}}/g,
    (_: any, argsKey: string) => {
      const res = args[argsKey] || ''
      return res
    },
  ) as Translations[T]

  return res
}

export default translate
